import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import $ from 'jquery';
import Header from "./include/Header";

import Apihelpers from './helper/ApiHelper';

class FuelTransmissionCreate extends Component {
  state = {
    MsgBoxText: '',
    formData:{
        type:'fuel',
        name:'',
        transmission_type:'',
        fuel_type:'',
        alias_name:'',
        commercial_type:''
    }
  };
  constructor(props) {
    super(props);

  }
  componentDidMount() {
    // setTimeout( () => {
    //   $("#mapping_fileter").select2('focus');
    // }, 500);
    $(document).ready(function () {
        $(".okBtn").click(function () {
          $(".customPopup").hide();
          //$(".customPopup .textA").css("color","");
        });
    });
  }
  inputHandle = (e) => {
    let val = e.target.value;
    let key = e.target.name;
    //console.log('val: ',val,', key: ',key);
    this.setState({
        formData : {...this.state.formData, [key]:val}
    })
  }
  
  submitForm = (e) => {
    e.preventDefault();
    let url = 'fueltype/creatfueltype';
    if (this.state.formData.type === 'transmission') {
        url = 'fueltype/creattransmissiontype';
    } else if (this.state.formData.type === 'aliases') {
        url = 'fueltype/creatnamealias';
    } else if (this.state.formData.type === 'commercial') {
      url = 'fueltype/creatcommercialtype';
  }
    Apihelpers.postdataresponse(url,this.state.formData)
    .then((res)=>{
        //console.log('res',res);
        if (res.data.status == true) {
            this.setState({
                MsgBoxText: res.data.message,
                formData : {
                    type:'fuel',
                    name:'',
                    transmission_type:'',
                    fuel_type:'',
                    alias_name:'',
                    commercial_type:''
                }
            });
            document.getElementById("createForm").reset();
            $(".customPopup").show();
            $(".customPopup .textA").css("color","green");
        } else {
            $(".customPopup").show();
            $(".customPopup .textA").css("color","red");
            this.setState({
                MsgBoxText: res.data.message
            });
        }
    })
  }
 
  render() {
    return (
      <div className="wrapper">
        <Header />
        <div className="container">
          <div className="fuelTypePage">
            <div className="titleRow">
              <div className="row">
                <div className="col">
                  <h3 className="title">Create</h3>
                </div>
                <div className="col-auto">
                    <NavLink to={"/admin/fuel-transmission-list"} className="backLink"><i className="fa fa-arrow-left"></i> Back to List</NavLink>
                </div>
              </div>
            </div>

            <div className="row">
                <div className="col-md-7">
                    {
                        //JSON.stringify(this.state.formData)
                    }
                    <form id="createForm" className="form" onSubmit={this.submitForm}>
                        <div className="form-group">
                            <label className="control-title">Type</label>
                            <div className="radioInputs">
                                <label className="radioInp">
                                    <input type="radio" value="fuel" name="type" checked={(this.state.formData.type === 'fuel')} onChange={this.inputHandle} />
                                    <span className="txt">Fuel Type</span>
                                </label>
                                <label className="radioInp">
                                    <input type="radio" value="transmission" checked={(this.state.formData.type === 'transmission')} name="type" onChange={this.inputHandle} />
                                    <span className="txt">Transmission Type</span>
                                </label>
                                <label className="radioInp">

                                    <input type="radio" value="commercial" name="type" checked={(this.state.formData.type === 'commercial')} onChange={this.inputHandle} />
                                    <span className="txt">Commercial Vehicle Type</span>
                                </label>
                                <label className="radioInp">
                                    <input type="radio" value="aliases" name="type" checked={(this.state.formData.type === 'aliases')} onChange={this.inputHandle} />
                                    <span className="txt">Aliases Type</span>
                                </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                {
                                    (this.state.formData.type === 'fuel') ?
                                    <div className="form-group">
                                        <label className="control-title typeLabel">Key</label>
                                        <select className="form-control" required name="fuel_type" onChange={this.inputHandle}>
                                            <option value="">--select--</option>
                                            <option value="Diesel">Diesel</option>
                                            <option value="Petrol">Petrol</option>
                                            <option value="CNG">CNG</option>
                                        </select>
                                    </div>
                                    : (this.state.formData.type === 'commercial') ?
                                    <div className="form-group">
                                        <label className="control-title typeLabel">Key</label>
                                        <select className="form-control" required name="commercial_type" onChange={this.inputHandle}>
                                            <option value="">--select--</option>
                                            <option value="Yes">Yes</option>
                                            <option value="No">No</option>
                                        </select>
                                    </div>
                                    : (this.state.formData.type === 'aliases') ?
                                    <div className="form-group">
                                        <label className="control-title typeLabel">Key</label>
                                        <input className="form-control" required name="alias_name" onChange={this.inputHandle} placeholder="Enter key" />
                                    </div>
                                    :
                                    <div className="form-group">
                                        <label className="control-title typeLabel">Key</label>
                                        <select className="form-control" required name="transmission_type" onChange={this.inputHandle}>
                                            <option value="">--select--</option>
                                            <option value="Automatic">Automatic</option>
                                            <option value="Manual">Manual</option>
                                        </select>
                                    </div>
                                }
                            </div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label className="control-title">Value</label>
                                    <input type="text" className="form-control" name="name" placeholder="Enter value" required onChange={this.inputHandle} />
                                </div>
                            </div>
                        </div>
                        <div className="btnRow">
                            <button className="backBtn" type="reset">Cancel</button>
                            <button className="yellowBtn" type="submit">Submit</button>
                        </div>
                    </form>
                </div>
			</div>

          </div>
        </div>
        <div className="customPopup" id="infoPopUp1">
          <div className="bgLayer"></div>
          <div className="popUpBox">
            <div className="popScroll">
              <div className="infoMessagePopUp">
                <div className="textA" style={{color:"green"}}>{this.state.MsgBoxText}</div>
                <div className="submitRow">
                  <button className="blueBtn okBtn" tabIndex="5" type="button">OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default FuelTransmissionCreate;
